import React from "react";
import { Box, CircularProgress } from "@mui/material";
import { useAppSelector } from "@/app/hooks";
import {
  selectBoardState,
  selectSelectedItem,
} from "@/features/bughurd/boardSelector";
import KanbanView from "./KanbanView";
import ListView from "./ListView";
import BoardTableView from "./BoardTableView";
import SettingsTab from "./SettingsTab";
import TagsTab from "./TagsTab";
import IntegrationTab from "./IntegrationTab";
import { MembersTab } from "./MembersTab";
import AppearanceTab from "./AppearanceTab";
import SnifferCDNDocumentation from "./SnifferCDNDocumentation";
import RecurringTaskTab from "./custom-hooks/RecurringTaskTab";
import BacklogTab from "./BacklogTab";
import SprintsTab from "./Sprint/SprintsTab";
import RetrospectivesTab from "./RetrospectivesTab";
import FeedbackTab from "./FeedbackTab";
import FeedbackWidgetConfigurator from "../bugherdComponents/feedbackWidgetConfigurator";
import { SprintWorkload } from "./Sprint/SprintWorkload/SprintWorkload";
import { TimelineView } from "./Sprint/TimelineView/TimelineView";
import SprintsCalendarView from "./Sprint/SprintsCalendarView";
import PMOHubDashboard from "./PMODashboard/PMOHubDashboard";

interface BoardContentProps {
  isInitialLoading: boolean;
  isMyTaskView: boolean;
  isCurrentUserClient?: boolean;
  projectDetails: any;
  handlePageChange: (
    columnId: string | null,
    paginationModel: any,
    viewType: string,
    subGroupId?: string,
  ) => void;
  refreshColumnData: (columnId?: string, subGroupId?: string) => Promise<void>;
  handleTaskUpdate: (
    taskId: string,
    updatedTask: any | null,
    newColumnId?: string,
  ) => void;
  handleLoadMore: (columnId: string, subGroupId?: string) => void;
  refetchBugList: () => void;
  refetchStatusList: () => void;
  refetchProjectDetails: () => void;
  reactFlow?: any;
  parentData?: any;
  selectedSprint?: any;
  allSprints?: any[];
}

const BoardContent: React.FC<BoardContentProps> = ({
  isInitialLoading,
  isMyTaskView,
  projectDetails,
  handlePageChange,
  refreshColumnData,
  handleTaskUpdate,
  handleLoadMore,
  refetchBugList,
  refetchStatusList,
  refetchProjectDetails,
  reactFlow,
  selectedSprint,
  allSprints,
  parentData,
  isCurrentUserClient,
}) => {
  console.log("🚀 ~ BoardContent ~ isCurrentUserClient:", isCurrentUserClient);
  const boardState = useAppSelector(selectBoardState);
  const selectedItem = useAppSelector(selectSelectedItem);
  const { viewType, backlogViewType } = boardState;
  const boardType = projectDetails?.boardType;

  if (
    boardType === "SCRUM" &&
    (selectedItem?.toLowerCase().includes("sprint") ||
      selectedItem === "Backlog")
  ) {
    switch (backlogViewType) {
      case "dashboard":
        return <PMOHubDashboard parentData={parentData} />;
      case "workload":
        return (
          <SprintWorkload
            sprintId={selectedSprint?._id}
            projectId={projectDetails?._id}
            sprint={selectedSprint}
            parentData={parentData}
          />
        );
      case "timeline":
        return <TimelineView />;
      case "calendar":
        if (selectedItem === "All Sprints") {
          return (
            <SprintsCalendarView
              sprints={allSprints}
              onSprintClick={(sprint) => {
                // Example: Open edit modal
                // setIsEditSprintModalOpen(true);
                // setSelectedSprintForEdit(sprint);
              }}
              onTaskClick={(task) => {
                // setSelectedTaskId(task._id);
                // setIsTaskModalOpen(true);
              }}
              onDateClick={(date) => {}}
              onPlusClick={(date) => {}}
            />
          );
        } else {
          return (
            <SprintsCalendarView
              sprints={[selectedSprint]}
              onSprintClick={(sprint) => {
                // Example: Open edit modal
                // setIsEditSprintModalOpen(true);
                // setSelectedSprintForEdit(sprint);
              }}
              onTaskClick={(task) => {
                // setSelectedTaskId(task._id);
                // setIsTaskModalOpen(true);
              }}
              onDateClick={(date) => {}}
              onPlusClick={(date) => {}}
            />
          );
        }

      case "list":
        return (
          <ListView
            handlePageChange={handlePageChange}
            refreshColumnData={refreshColumnData}
            isMyTaskView={isMyTaskView}
            isInitialLoading={isInitialLoading}
          />
        );
      case "table":
        return (
          <BoardTableView
            handlePageChange={handlePageChange}
            refreshColumnData={refreshColumnData}
            isMyTaskView={isMyTaskView}
          />
        );
      case "kanban":
        return (
          <>
            <KanbanView
              handleTaskUpdate={handleTaskUpdate}
              refreshColumnData={refreshColumnData}
              handleLoadMore={handleLoadMore}
              isMyTaskView={isMyTaskView}
              reactFlow={reactFlow}
            />
          </>
        );
      case "allSprint":
        return <SprintsTab />;
      case "backlog":
        return <BacklogTab />;
      case "board":
        return <BacklogTab />;
      default:
        return null;
    }
  }
  if (boardType === "KANBAN" && selectedItem === "Task Board") {
    switch (viewType) {
      case "dashboard":
        return <PMOHubDashboard />;
      case "list":
        return (
          <ListView
            handlePageChange={handlePageChange}
            refreshColumnData={refreshColumnData}
            isMyTaskView={isMyTaskView}
            isInitialLoading={isInitialLoading}
          />
        );
      case "table":
        return (
          <BoardTableView
            handlePageChange={handlePageChange}
            refreshColumnData={refreshColumnData}
            isMyTaskView={isMyTaskView}
            reactFlow={reactFlow}
          />
        );
      case "kanban":
        return (
          <KanbanView
            handleTaskUpdate={handleTaskUpdate}
            refreshColumnData={refreshColumnData}
            handleLoadMore={handleLoadMore}
            isMyTaskView={isMyTaskView}
            reactFlow={reactFlow}
          />
        );
      default:
        return null;
    }
  }
  if (isMyTaskView) {
    if (viewType === "kanban") {
      return (
        <KanbanView
          handleTaskUpdate={handleTaskUpdate}
          refreshColumnData={refreshColumnData}
          handleLoadMore={handleLoadMore}
          isMyTaskView={isMyTaskView}
          reactFlow={reactFlow}
        />
      );
    } else if (viewType === "list") {
      return (
        <ListView
          handlePageChange={handlePageChange}
          refreshColumnData={refreshColumnData}
          isMyTaskView={isMyTaskView}
          isInitialLoading={isInitialLoading}
        />
      );
    } else if (viewType === "table") {
      return (
        <BoardTableView
          handlePageChange={handlePageChange}
          refreshColumnData={refreshColumnData}
          isMyTaskView={isMyTaskView}
        />
      );
    }
  }
  // Render other tabs
  switch (selectedItem) {
    case "Project Settings":
      return (
        <SettingsTab
          projectDetails={projectDetails}
          onProjectUpdate={refetchProjectDetails}
        />
      );
    case "Tags":
      return <TagsTab />;
    // case "Backlog":
    //   return <BacklogTab />;
    case "Integrations":
      return <IntegrationTab projectDetails={projectDetails} />;
    case "Members":
      return (
        <MembersTab
          projectDetails={projectDetails}
          onProjectUpdate={refetchProjectDetails}
        />
      );
    case "Appearance":
      return (
        <AppearanceTab
          isMyTaskView={isMyTaskView}
          projectDetails={projectDetails}
        />
      );
    case "Live Logs Docs":
      return (
        <SnifferCDNDocumentation mode="page" projectDetails={projectDetails} />
      );
    case "Recurring Tasks":
      return (
        <RecurringTaskTab
          handlePageChange={handlePageChange}
          refreshColumnData={refreshColumnData}
          isMyTaskView={isMyTaskView}
        />
      );
    case "Feedback":
      return (
        <FeedbackTab
          projectDetails={projectDetails}
          isCurrentUserClient={isCurrentUserClient}
        />
      );
    case "Feedback Config":
      return <FeedbackWidgetConfigurator />;
    default:
      return null;
  }
};

export default BoardContent;
